// extracted by mini-css-extract-plugin
export default {"content-padding":"General_content-padding__FykiK"};